import styled from "styled-components"
import Checkbox from "../../../Ui/Form/Checkbox"

export const Divider = styled.div`
  border-top: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  margin-top: 3rem;
`

export const Label = styled.h3`
  margin-bottom: 0;
`

export const Description = styled.span`
  color: ${(p) => p.theme.colors.greyDarker};
`

export const SubOutcomeTitle = styled.span`
  text-align: left;
  font-weight: 700;
`

export const SubOutcomes = styled.div`
  margin: 2rem 0;

  p {
    text-align: center;
  }
`

export const StyledCheckbox = styled(Checkbox)`
  padding: 0.5rem 0 0;
  margin-bottom: 1.5rem;
`

export const SubOutcomeHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`

export const ButtonWrapper = styled.div`
  margin: 2rem 0;
  display: flex;

  button {
    margin-right: 0.5rem;
  }
`
